import { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import * as AppConstants from "../constants/AppConstants";
import {
  APP_ACCESS_TYPES,
  SOLVER_TYPES_MAP,
  TIME_FILTER_TYPES,
} from "../constants/TemplatesConstants";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { filter, toUpper, isEqual } from "lodash";

export const useFetchItemsList = (currentPage, fetchListThunk) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { access } = useParams();
  const [refreshCount, setRefreshCount] = useState(0);
  const prevQueryParamsRef = useRef({});

  const getFilterInputFromQueryParams = (queryParams) => {
    const filter_keyword = queryParams.get("q");
    const filter_solver = queryParams.get("solvers");
    const filter_time = queryParams.get("time");
    const filter_topic = queryParams.get("topics");
    const filter_industry = queryParams.get("industries");
    const filter_owner = queryParams.get("owner");

    const filter_access = access !== undefined && access in APP_ACCESS_TYPES ? APP_ACCESS_TYPES[access] : null;
    const filterInput = {};

    if (filter_keyword) filterInput.keyword = filter_keyword;
    if (filter_solver)
      filterInput.solver = filter_solver
        .split(",")
        .map((item) => SOLVER_TYPES_MAP[item]);
    if (filter_time) filterInput.time = TIME_FILTER_TYPES[filter_time];
    if (filter_topic) filterInput.topic = filter_topic.split(",").map((item) => toUpper(item));
    if (filter_industry) filterInput.industry = filter_industry.split(",").map((item) => toUpper(item));
    if (filter_access) filterInput.access = filter_access;
    if (filter_owner) filterInput.owner = filter_owner;

    return filterInput;
  };
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const filterInput = getFilterInputFromQueryParams(queryParams);
    const prevQueryParams = prevQueryParamsRef.current;

    // Check if the filterInput is different from the previous queryParams
    if (!isEqual(filterInput, prevQueryParams) || refreshCount > 0) {
      dispatch(
        fetchListThunk(
          filterInput,
          (currentPage - 1) * AppConstants.APP_DEFAULT_PAGE_SIZE,
          AppConstants.APP_DEFAULT_PAGE_SIZE
        )
      );
      // Update the ref with the new query params for the next comparison
      prevQueryParamsRef.current = filterInput;
    }
  }, [location.search, currentPage, dispatch, access, refreshCount]);

  const retryFetch = () => {
    setRefreshCount((prevCount) => prevCount + 1);
  };

  return { retryFetch };
};
